export const MFA_TIMER = 300000 * 2; // 5 minutes * 2 = 10 minutes

export default MFA_TIMER;
